import { createSelector } from 'reselect';

import { RootState } from '@/app/store';

const selectHistoryState = (state: RootState) => state.history;

export const selectRollsHistory = createSelector(selectHistoryState, (h) => h.items);
export const selectHistoryPage = createSelector(selectHistoryState, (h) => h.page);
export const selectHistoryHasMore = createSelector(selectHistoryState, (h) => h.hasMore);
export const selectHistoryLoading = createSelector(selectHistoryState, (h) => h.loading);
export const selectHistoryFetchedAt = createSelector(selectHistoryState, (h) => h.fetchedAt);
